import { CaretDownIcon } from './CaretDownIcon';
import { CheckCircleIcon } from './CheckCircleIcon';
import { ExclamationIcon } from './ExclamationIcon';
import { FilterSliderIcon } from './FilterSliderIcon';
import { MailIcon } from './MailIcon';
import { MathSymbolsIcon } from './MathSymbolsIcon';
import { PhoneIcon } from './PhoneIcon';
import { QuestionMarkIcon } from './QuestionMarkIcon';
import { ExclamationFilledIcon } from './ExclamationFilledIcon';
import { SpecialOfferIcon } from './SpecialOfferIcon'

export { CaretDownIcon, CheckCircleIcon, ExclamationIcon, FilterSliderIcon, MailIcon, MathSymbolsIcon, PhoneIcon, QuestionMarkIcon, ExclamationFilledIcon, SpecialOfferIcon };

export default {
    CaretDownIcon,
    CheckCircleIcon,
    ExclamationIcon,
    ExclamationFilledIcon,
    FilterSliderIcon,
    MailIcon,
    MathSymbolsIcon,
    PhoneIcon,
    QuestionMarkIcon,
    SpecialOfferIcon
};
